/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InternalProcessAliasEventSyncRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/internal_process_alias_event_sync.pb'
import {InternalProcessAliasEventSyncResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/internal_process_alias_event_sync.pb'


export const internalProcessAliasEventSync = (request: InternalProcessAliasEventSyncRequest, options?: CashRequestOptions) => post<InternalProcessAliasEventSyncRequest, InternalProcessAliasEventSyncResponse>("/2.0/cash/internal-process-alias-event-sync", request, {...options, rejectOnError: true })